import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import moment from 'moment-jalaali';

const getStoredFilters = (): any => {
  try {
    return JSON.parse(sessionStorage.getItem('filters') || '{}') || {};
  } catch {
    return {};
  }
};

const getStoredSeen = (): string => {
  const f = getStoredFilters();
  if (f.seen === "true" || f.seen === "false") return f.seen;
  // backward compatibility with the legacy `not_seen: true` flag (header "view all notifications")
  return f.not_seen === true ? "false" : "";
};

const buildSubmittedFiltersFromStorage = () => {
  const f = getStoredFilters();
  return {
    subject: f.subject || "",
    sender: f.sender || "",
    receiver: f.receiver || "",
    from_date: f.from_date || null,
    to_date: f.to_date || null,
    ticket_id: f.ticket_id || "",
    leadState: f.lead_state || "",
    dealState: f.deal_state || "",
    ticketState: f.ticket_state || "",
    seen: getStoredSeen(),
  };
};

interface IProps {
  userData?: any;
}
interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  openModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  isFilterApplying: boolean;
  isUploadingTicket: boolean;
  tecketsList?: any;
  page: number;
  from_date: any;
  to_date: any;
  count: number;
  subject: string;
  sender: string;
  receiver: string;
  ticket_id: string;
  leadState: string;
  statesList: any;
  dealState:string;
  seen:string;
  dealsList:any;
  shouldRedirect:boolean;
  queryParams:string;
  selectedItem:any;
  addTicketModal:boolean;
  errorsList:any;
  value: string;
  ticketStatesList:any,
  ticketState:string,
  image: any;
  type: string;
  subtitle: string;
  description: string;
  assignPersonsList:any;
  assgin_to_id:string;
  rowsCountList:any;
  submittedFilters: any;
}
export class TicketingController extends Component<IProps, IState> {
  datePickerRef: any;
  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }
  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    openModal: false,
    openActionModal: false,
    loading: false,
    isFilterApplying: false,
    isUploadingTicket: false,
    tecketsList: [],
    ticketStatesList:[],
    ticketState:sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.ticket_state
    : "",
    page: sessionStorage.getItem('filters') ? parseInt(JSON.parse(sessionStorage.getItem('filters') || '{}')?.page)
    : 1 ,
    subject: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.subject
    : "",
    count: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.count
    : 6,
    sender: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.sender
    : "",
    receiver: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.receiver
    : "",
    from_date: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}').from_date : null,
    to_date: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}').to_date : null,
    ticket_id: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.ticket_id
    : "",
    leadState: sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.lead_state
    : "",
    dealState:sessionStorage.getItem('filters') ? JSON.parse(sessionStorage.getItem('filters') || '{}')?.deal_state
    : "",
    seen: getStoredSeen(),
    dealsList:[],
    statesList: [],
    shouldRedirect:false,
    queryParams:"",
    selectedItem:null,
    addTicketModal:false,
    errorsList:[],
    value: "",
    image: null,
    type: "",
    subtitle: "",
    description: "",
    assgin_to_id:"",
    assignPersonsList:[],
    rowsCountList:[6, 10, 50, 100],
    submittedFilters: buildSubmittedFiltersFromStorage(),
  };
  id: any = this.state.open ? 'simple-popper' : undefined;
  search = async (e: any) => {
    this.setState({ str: e })
  };
  handleChange = (e: any) => {
    this.setState({ leadState: e.target.value, page:1 });
      const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, lead_state: e.target.value, page:1 };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  handleChangeDealState = (e: any) => {
    this.setState({ dealState: e.target.value, page:1 });
      const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, deal_state: e.target.value, page:1 };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  
  handleChangeTicketState = (e: any) => {
    this.setState({ ticketState: e.target.value, page:1 });
      const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, ticket_state: e.target.value, page:1 };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };

  handleSeenChange = (e: any) => {
    this.setState({ seen: e.target.value, page:1 });
      const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, seen: e.target.value, page:1 };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };
  getTicketsList = async () => {
    this.setState({ loading: true, isFilterApplying: true })
    const { page, count,  ticketState,subject, sender, receiver, ticket_id, from_date, to_date, leadState, seen , 
      dealState
     } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count,
      subject: subject ? subject : null,
      sender: sender ? sender : null,
      receiver: receiver ? receiver : null,
      ticket_id: ticket_id ? ticket_id : null,
      from_date: from_date ? from_date : null,
      to_date: to_date ? to_date : null,
      lead_state: leadState ? leadState : null,
      deal_state: dealState ? dealState : null,
      not_seen: seen === "true" ? false : seen === "false" ? true : null,
      ticket_state: ticketState ? ticketState :null,

    }
    let url = new URL(`${AppConstants.base_url_api}tickets`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value !== null && value !== undefined && value !== "") {
        url.searchParams.append(key, String(value))
      }
    }
    try {
      const response = await service.Ticket.list(url.search);
      if (response) {
        this.setState({ tecketsList: response?.data?.data, openModal: false })
        this.getStatesList();
        this.getDealsList();
        this.getTicketsState();
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
    finally {
      this.setState({ isFilterApplying: false })
    }
  };


  
  
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, page: value };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter));
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getTicketsList()
    }, 800);
  }
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page: 1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, count: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter));
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getTicketsList()
    }, 800);
  }
  handleSubjectChange = (value: any) => {
    this.setState({ subject: value, page:1 })
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, subject: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  }
  handleChangeFromDate = (value: any) => {
    this.setState({ from_date:value ? fixNumbers(value.format()) : null, page:1 })
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, from_date: value ? fixNumbers(value.format()) : null, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))

  };
  handleCountChange = (value: any) => {
    this.setState({ count: value, page:1 })
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, count: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  handleChangeToDate = (value: any) => {
    this.setState({ to_date:value ? fixNumbers(value.format()) : null, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, to_date: value ? fixNumbers(value.format()) : null, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  handleSender = (value: any) => {
    this.setState({ sender: value, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, sender: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  handleReceiver = (value: any) => {
    this.setState({ receiver: value, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, receiver: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyFromDate= () => {
    this.setState({ from_date: null, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, from_date: "",page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyToDate= () => {
    this.setState({ to_date: null, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, to_date: "", page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyState= () => {
    this.setState({ leadState: "", page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, lead_state: "", page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, count: 6, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyDealState= () => {
    this.setState({ dealState: "", page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, deal_state: "", page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptyTicketState= () => {
    this.setState({ ticketState: "", page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, ticket_state: "", page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  emptySeen= () => {
    this.setState({ seen: "", page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, seen: "", page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  handleChangeTicketId = (value:any) => {
    this.setState({ ticket_id: value, page:1 });
    const filters =  JSON.parse(sessionStorage.getItem('filters') || "{}");
    const updatedFilter = { ...filters, ticket_id: value, page:1 };
    sessionStorage.setItem('filters', JSON.stringify(updatedFilter))
  };
  getTicketsState = async () => {
    try {
      const response = await service.Ticket.states();
      if (response) {
        this.setState({ ticketStatesList: response?.data?.data?.list, loading: false })

        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  getDealsList = async () => {
    try {
      const response = await service.Deals.statesList();
      if (response) {
        this.setState({ dealsList: response?.data?.data?.list, loading: false })

        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  getStatesList = async () => {
    try {
      const response = await service.Leads.states();
      if (response) {
        this.setState({ statesList: response?.data?.data?.list, loading: false })

        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  showTicketDetails =(item:any)=>{
    const { leadState, ticketState, dealState, count, page, from_date, to_date, subject, sender,
      receiver, ticket_id, seen
     } = this.state;
    
    let queryParams = '';
    if (leadState) {
      queryParams += `lead_state=${leadState}&`;
    }
    if (ticketState) {
      queryParams += `ticket_state=${ticketState}&`;
    }
    if (dealState) {
      queryParams += `deal_state=${dealState}&`;
    }
    if (count) {
      queryParams += `count=${count}&`;
    }
    if (page) {
      queryParams += `page=${page}&`;
    }
    if (from_date) {
      queryParams += `from_date=${from_date}&`;
    }
    if (to_date) {
      queryParams += `to_date=${to_date}&`;
    }  if (subject) {
      queryParams += `subject=${subject}&`;
    }
    if (sender) {
      queryParams += `sender=${sender}&`;
    }
    if (receiver) {
      queryParams += `receiver=${receiver}&`;
    }
    if (ticket_id) {
      queryParams += `ticket_id=${ticket_id}&`;
    }
    if (seen) {
      queryParams += `seen=${seen}&`;
    }
      return `/details-ticket/${item?.id}?${queryParams.slice(0, -1)}`
    
  }
  handleAddTicketModal = () =>{
    this.setState({addTicketModal: true});
    this.getAssignPersonsList();
  }
  getAssignPersonsList = async () => {
    try {
      const response = await service.Ticket.assignPersonsList();
      if (response) {
            this.setState({ assignPersonsList: response?.data?.data?.list })
      } else {
      }
    } catch (error) {
      // throw error;
    }
  };
  async uploadTicket() {
    this.setState({ isUploadingTicket: true });
    const { subtitle, description , assgin_to_id} = this.state;
    const schema = yup.object({
        subtitle: yup.string().required("موضوع تیکت اجباری می باشد"),
        description: yup.string().required("توضیحات اجباری می باشد"),
        assgin_to_id: yup.string().required("انتخاب شخص اجباری می باشد"),
    });
    try {
        await schema.validate({ subtitle, description , assgin_to_id }, { abortEarly: false });
        const response = await service.Ticket.create( subtitle, description , assgin_to_id);
        
        if (response) {
          if(response?.status === 200){
              this.setState({ addTicketModal:false,errorsList: [] , loading: false, subtitle:"", description:"",assgin_to_id:""})
              toast.success(response?.data?.message);
 if (response?.data?.data?.id) {
            window.location.href = `/details-ticket/${response?.data?.data?.id}`;
        }          }

        } else {
            this.setState({ addTicketModal:false })
        }


    } catch (err: any) {
        this.setState({ errorsList: err.inner})
    }
    finally {
      this.setState({ isUploadingTicket: false });
    }
};

closeModal = () =>{
  this.setState({ openModal: false});
}

hasActiveFilter = () => {
  const sf = this.state.submittedFilters;
  if (!sf) return false;
  const { subject, sender, receiver, from_date, to_date, leadState, dealState, ticketState, ticket_id, seen } = sf;
  return !!(subject || sender || receiver || from_date || to_date || leadState || dealState || ticketState || ticket_id || seen);
};  getActiveFiltersList = () => {
  const { submittedFilters } = this.state;
  const sf = submittedFilters || {};
  const items: { label: string; value: string; onRemove: () => void }[] = [];

  const removeFilter = (key: string, stateKey?: string) => {
    const newSf = { ...sf, [key]: null };
    const newState: any = { submittedFilters: newSf };
    if (stateKey) {
      newState[stateKey] = "";
    }
    // keep sessionStorage in sync so the removal survives a page refresh
    const storageKeyMap: any = {
      subject: "subject",
      sender: "sender",
      receiver: "receiver",
      from_date: "from_date",
      to_date: "to_date",
      ticket_id: "ticket_id",
      leadState: "lead_state",
      dealState: "deal_state",
      ticketState: "ticket_state",
      seen: "seen",
    };
    const storageKey = storageKeyMap[key];
    if (storageKey) {
      const filters = JSON.parse(sessionStorage.getItem('filters') || "{}");
      const updatedFilter = { ...filters, [storageKey]: "" };
      sessionStorage.setItem('filters', JSON.stringify(updatedFilter));
    }
    this.setState(newState, this.getTicketsList);
  };

  if (sf.subject) {
    items.push({ label: "عنوان تیکت", value: sf.subject, onRemove: () => removeFilter("subject", "subject") });
  }
  if (sf.sender) {
    items.push({ label: "فرستنده", value: sf.sender, onRemove: () => removeFilter("sender", "sender") });
  }
  if (sf.receiver) {
    items.push({ label: "گیرنده", value: sf.receiver, onRemove: () => removeFilter("receiver", "receiver") });
  }
  if (sf.ticket_id) {
    items.push({ label: "شماره تیکت", value: sf.ticket_id, onRemove: () => removeFilter("ticket_id", "ticket_id") });
  }
  if (sf.from_date) {
    items.push({ label: "از تاریخ", value: sf.from_date, onRemove: () => removeFilter("from_date", "from_date") });
  }
  if (sf.to_date) {
    items.push({ label: "تا تاریخ", value: sf.to_date, onRemove: () => removeFilter("to_date", "to_date") });
  }
  if (sf.leadState) {
    items.push({ label: "وضعیت سرنخ", value: sf.leadState, onRemove: () => removeFilter("leadState", "leadState") });
  }
  if (sf.dealState) {
    items.push({ label: "وضعیت معامله", value: sf.dealState, onRemove: () => removeFilter("dealState", "dealState") });
  }
  if (sf.ticketState) {
    items.push({ label: "وضعیت تیکت", value: sf.ticketState, onRemove: () => removeFilter("ticketState", "ticketState") });
  }
  if (sf.seen) {
    items.push({ label: "دیده شده", value: sf.seen === "true" ? "بله" : "خیر", onRemove: () => removeFilter("seen", "seen") });
  }

  return items;
};

handleApplyFilter = () => {
  const { subject, sender, receiver, from_date, to_date, leadState, dealState, ticketState, ticket_id, seen } = this.state;
  this.setState({
    page: 1,
    submittedFilters: { subject, sender, receiver, from_date, to_date, leadState, dealState, ticketState, ticket_id, seen },
    openModal: false,
  }, this.getTicketsList);
};

}
export default TicketingController;